import { environment } from '~env/environment';

export const API_CHECK_INVENTORY_ROUTE = () => `${environment.svcCheckoutBaseUrl()}/api/v1/public/cart/offer-inventory`;
export const API_CART_ROUTE = () => `${environment.svcCheckoutBaseUrl()}/api/v1`;
